import { FC } from "react";
import { observer } from "mobx-react-lite";
import { ExpandableKeys } from "../../store/core";
import ICheckbox from "../ICheckbox";

import styles from "./FieldsFilterSelector.module.scss";

interface IFieldsFilterSelectorProps {
    fieldsKeys: ExpandableKeys,
    unCheckableFields: Array<any>,
    checkableFields: Array<any>,
}

export const FieldsFilterSelector: FC<IFieldsFilterSelectorProps> = observer(({fieldsKeys, unCheckableFields, checkableFields}) => {
    const unCheckableFieldsKeys = unCheckableFields.map(({name}) => name);
    const checkableFieldsKeys = checkableFields.map(({name}) => name);
    
    const isSelectedAll = (unCheckableFieldsKeys.length + checkableFieldsKeys.length) === fieldsKeys.keys.length

    const toggleCheckbox = (name) => {
        if (fieldsKeys.keys.includes(name)) {
            fieldsKeys.remove(name);
        } else {
            fieldsKeys.add(name);
        }
    }

    return <ul>
        <li className={styles["checkbox-item"]}>
            <ICheckbox
                checked={isSelectedAll}
                label="Выбрать все"
                onChange={() => {
                    fieldsKeys.setKeys(isSelectedAll ? unCheckableFieldsKeys : [...unCheckableFieldsKeys,...checkableFieldsKeys]);
                }}
            />
        </li>
        {unCheckableFields.map((field) => (
            <li className={styles["checkbox-item"]}>
                <ICheckbox
                    checked={fieldsKeys.keys.includes(field.name)}
                    label={field.placeholder}
                    disabled={true}
                />
            </li>
        ))}
        {checkableFields.map((field) => (
            <li className={styles["checkbox-item"]}>
                <ICheckbox
                    checked={fieldsKeys.keys.includes(field.name)}
                    label={field.placeholder}
                    onChange={e => toggleCheckbox(field.name)}
                />
            </li>
        ))}
    </ul>
});